import useStyleUtils from "../../../utilities/styles";
import { Skeleton, SkeletonItem } from "@fluentui/react-components";
import { Col, Row } from "react-grid-system";

const Placeholder = () => {
    const style = useStyleUtils();

    return (
        <Row>
            <Col xs={12}>
                <Row>
                    <Col xs={12} md={8} lg={6}>
                        <Skeleton>
                            <SkeletonItem size={36} className={style.mb3} />
                        </Skeleton>
                    </Col>
                    {
                        Array.from({ length: 6 }).map((_, index) => (
                            <Col key={index} sm={12}>
                                <Row>
                                    <Col key={index} xs={12} md={6} lg={4}>
                                        <Skeleton>
                                            <SkeletonItem size={24} className={style.mb1} />
                                        </Skeleton>
                                    </Col>
                                </Row>
                            </Col>
                        ))
                    }
                </Row>
            </Col>
        </Row>
    );
};

export default Placeholder;